export const spoke = function(ctx: any) {
  ctx.save();
  ctx.strokeStyle = "rgba(0,0,0,0)";
  ctx.miterLimit = 4;
  ctx.save();
  ctx.beginPath();
  ctx.moveTo(138.64, 185.42);
  ctx.bezierCurveTo(
    139.07,
    185.22,
    139.48999999999998,
    185.01999999999998,
    139.92,
    184.82
  );
  ctx.bezierCurveTo(
    140.73999999999998,
    184.42,
    141.55999999999997,
    184.01999999999998,
    142.36999999999998,
    183.6
  );
  ctx.bezierCurveTo(
    150.79999999999998,
    179.25,
    158.71999999999997,
    173.53,
    165.76999999999998,
    166.4
  );
  ctx.bezierCurveTo(172.82, 159.28, 178.48, 151.28, 182.79, 142.75);
  ctx.bezierCurveTo(
    183.20999999999998,
    141.93,
    183.60999999999999,
    141.1,
    184,
    140.27
  );
  ctx.bezierCurveTo(184.2, 139.84, 184.4, 139.41, 184.6, 138.98000000000002);
  ctx.bezierCurveTo(
    185.10999999999999,
    137.85000000000002,
    185.6,
    136.72000000000003,
    186.06,
    135.57000000000002
  );
  ctx.bezierCurveTo(
    186.12,
    135.43000000000004,
    186.17000000000002,
    135.3,
    186.23,
    135.16000000000003
  );
  ctx.bezierCurveTo(
    190.59,
    124.28000000000003,
    193,
    112.40000000000002,
    193,
    99.96000000000002
  );
  ctx.bezierCurveTo(
    193,
    87.52000000000002,
    190.59,
    75.64000000000001,
    186.23,
    64.76000000000002
  );
  ctx.bezierCurveTo(
    186.17999999999998,
    64.62000000000002,
    186.11999999999998,
    64.49000000000002,
    186.06,
    64.35000000000002
  );
  ctx.bezierCurveTo(
    185.59,
    63.200000000000024,
    185.11,
    62.060000000000024,
    184.6,
    60.940000000000026
  );
  ctx.bezierCurveTo(
    184.41,
    60.510000000000026,
    184.2,
    60.08000000000003,
    184,
    59.65000000000003
  );
  ctx.bezierCurveTo(
    183.61,
    58.82000000000003,
    183.21,
    57.99000000000003,
    182.79,
    57.17000000000003
  );
  ctx.bezierCurveTo(
    178.48,
    48.650000000000034,
    172.82,
    40.650000000000034,
    165.76999999999998,
    33.52000000000003
  );
  ctx.bezierCurveTo(
    158.71999999999997,
    26.39000000000003,
    150.79999999999998,
    20.68000000000003,
    142.36999999999998,
    16.320000000000032
  );
  ctx.bezierCurveTo(
    141.55999999999997,
    15.900000000000032,
    140.73999999999998,
    15.490000000000032,
    139.92,
    15.100000000000032
  );
  ctx.bezierCurveTo(
    139.5,
    14.900000000000032,
    139.07,
    14.690000000000031,
    138.64,
    14.500000000000032
  );
  ctx.bezierCurveTo(
    137.52999999999997,
    13.980000000000032,
    136.39999999999998,
    13.490000000000032,
    135.26,
    13.020000000000032
  );
  ctx.bezierCurveTo(
    135.12,
    12.960000000000031,
    134.98999999999998,
    12.910000000000032,
    134.85,
    12.850000000000032
  );
  ctx.bezierCurveTo(124.1, 8.44, 112.34, 6, 100.03, 6);
  ctx.bezierCurveTo(87.72, 6, 75.97, 8.44, 65.2, 12.85);
  ctx.bezierCurveTo(65.06, 12.91, 64.93, 12.959999999999999, 64.79, 13.02);
  ctx.bezierCurveTo(
    63.650000000000006,
    13.49,
    62.53000000000001,
    13.98,
    61.410000000000004,
    14.5
  );
  ctx.bezierCurveTo(60.980000000000004, 14.7, 60.56, 14.9, 60.13, 15.1);
  ctx.bezierCurveTo(59.31, 15.5, 58.49, 15.9, 57.68, 16.32);
  ctx.bezierCurveTo(49.25, 20.67, 41.33, 26.39, 34.28, 33.519999999999996);
  ctx.bezierCurveTo(
    27.23,
    40.63999999999999,
    21.57,
    48.63999999999999,
    17.26,
    57.169999999999995
  );
  ctx.bezierCurveTo(
    16.84,
    57.989999999999995,
    16.44,
    58.81999999999999,
    16.05,
    59.64999999999999
  );
  ctx.bezierCurveTo(
    15.850000000000001,
    60.07999999999999,
    15.65,
    60.49999999999999,
    15.46,
    60.93999999999999
  );
  ctx.bezierCurveTo(
    14.950000000000001,
    62.06999999999999,
    14.46,
    63.209999999999994,
    13.99,
    64.35999999999999
  );
  ctx.bezierCurveTo(
    13.94,
    64.49999999999999,
    13.88,
    64.62999999999998,
    13.83,
    64.76999999999998
  );
  ctx.bezierCurveTo(
    9.469999999999999,
    75.64999999999998,
    7.05,
    87.52999999999999,
    7.05,
    99.96999999999998
  );
  ctx.bezierCurveTo(
    7.05,
    112.40999999999998,
    9.46,
    124.28999999999999,
    13.83,
    135.17
  );
  ctx.bezierCurveTo(
    13.88,
    135.30999999999997,
    13.94,
    135.44,
    13.99,
    135.57999999999998
  );
  ctx.bezierCurveTo(
    14.46,
    136.73,
    14.95,
    137.86999999999998,
    15.46,
    138.99999999999997
  );
  ctx.bezierCurveTo(
    15.65,
    139.42999999999998,
    15.850000000000001,
    139.85999999999999,
    16.05,
    140.28999999999996
  );
  ctx.bezierCurveTo(
    16.44,
    141.11999999999998,
    16.85,
    141.94999999999996,
    17.26,
    142.76999999999995
  );
  ctx.bezierCurveTo(
    21.57,
    151.28999999999996,
    27.230000000000004,
    159.28999999999996,
    34.28,
    166.41999999999996
  );
  ctx.bezierCurveTo(
    41.33,
    173.53999999999996,
    49.25,
    179.25999999999996,
    57.68,
    183.61999999999995
  );
  ctx.bezierCurveTo(
    58.49,
    184.03999999999994,
    59.31,
    184.44999999999996,
    60.13,
    184.83999999999995
  );
  ctx.bezierCurveTo(
    60.550000000000004,
    185.03999999999994,
    60.980000000000004,
    185.24999999999994,
    61.410000000000004,
    185.43999999999994
  );
  ctx.bezierCurveTo(
    62.52,
    185.95999999999995,
    63.650000000000006,
    186.44999999999993,
    64.79,
    186.91999999999993
  );
  ctx.bezierCurveTo(
    64.93,
    186.97999999999993,
    65.06,
    187.02999999999994,
    65.2,
    187.08999999999992
  );
  ctx.bezierCurveTo(
    75.96000000000001,
    191.49999999999991,
    87.72,
    193.9399999999999,
    100.03,
    193.9399999999999
  );
  ctx.bezierCurveTo(
    112.34,
    193.9399999999999,
    124.09,
    191.49999999999991,
    134.86,
    187.08999999999992
  );
  ctx.bezierCurveTo(
    135,
    187.02999999999992,
    135.13000000000002,
    186.9799999999999,
    135.27,
    186.91999999999993
  );
  ctx.bezierCurveTo(136.4, 186.43, 137.53, 185.94, 138.64, 185.42);
  ctx.closePath();
  ctx.moveTo(131.28, 172.42);
  ctx.bezierCurveTo(
    130.84,
    172.60999999999999,
    130.4,
    172.79999999999998,
    129.96,
    172.98999999999998
  );
  ctx.bezierCurveTo(
    129.52,
    173.17,
    129.07000000000002,
    173.35999999999999,
    128.63,
    173.52999999999997
  );
  ctx.bezierCurveTo(
    128.43,
    173.60999999999999,
    128.24,
    173.68999999999997,
    128.04,
    173.75999999999996
  );
  ctx.bezierCurveTo(
    123.35999999999999,
    175.56999999999996,
    118.53999999999999,
    176.89999999999995,
    113.66,
    177.76999999999995
  );
  ctx.lineTo(113.66, 133.20999999999995);
  ctx.lineTo(144.82999999999998, 164.71999999999994);
  ctx.bezierCurveTo(
    140.76999999999998,
    167.59999999999994,
    136.42999999999998,
    170.09999999999994,
    131.85999999999999,
    172.15999999999994
  );
  ctx.bezierCurveTo(131.67, 172.25, 131.48, 172.33, 131.28, 172.42);
  ctx.closePath();
  ctx.moveTo(72.02, 173.76);
  ctx.bezierCurveTo(
    71.82,
    173.67999999999998,
    71.63,
    173.60999999999999,
    71.42999999999999,
    173.53
  );
  ctx.bezierCurveTo(
    70.97999999999999,
    173.35,
    70.53999999999999,
    173.17,
    70.1,
    172.99
  );
  ctx.bezierCurveTo(69.66, 172.8, 69.22, 172.62, 68.78, 172.42000000000002);
  ctx.bezierCurveTo(
    68.59,
    172.33,
    68.39,
    172.25000000000003,
    68.2,
    172.16000000000003
  );
  ctx.bezierCurveTo(
    63.63,
    170.09000000000003,
    59.290000000000006,
    167.59000000000003,
    55.230000000000004,
    164.72000000000003
  );
  ctx.lineTo(86.4, 133.21000000000004);
  ctx.lineTo(86.4, 177.77000000000004);
  ctx.bezierCurveTo(81.52, 176.9, 76.7, 175.57, 72.02, 173.76);
  ctx.closePath();
  ctx.moveTo(28.59, 132.13);
  ctx.bezierCurveTo(28.5, 131.94, 28.419999999999998, 131.74, 28.34, 131.54);
  ctx.bezierCurveTo(28.15, 131.1, 27.96, 130.65, 27.78, 130.20999999999998);
  ctx.bezierCurveTo(
    27.6,
    129.76,
    27.42,
    129.30999999999997,
    27.240000000000002,
    128.85999999999999
  );
  ctx.bezierCurveTo(
    27.160000000000004,
    128.66,
    27.090000000000003,
    128.45999999999998,
    27.01,
    128.26999999999998
  );
  ctx.bezierCurveTo(
    25.220000000000002,
    123.53999999999998,
    23.900000000000002,
    118.66999999999999,
    23.040000000000003,
    113.72999999999999
  );
  ctx.lineTo(67.13000000000001, 113.72999999999999);
  ctx.lineTo(35.96000000000001, 145.23999999999998);
  ctx.bezierCurveTo(33.11, 141.13, 30.64, 136.75, 28.59, 132.13);
  ctx.closePath();
  ctx.moveTo(27.01, 71.65);
  ctx.bezierCurveTo(27.09, 71.45, 27.16, 71.25, 27.240000000000002, 71.06);
  ctx.bezierCurveTo(
    27.410000000000004,
    70.61,
    27.590000000000003,
    70.16,
    27.78,
    69.71000000000001
  );
  ctx.bezierCurveTo(
    27.96,
    69.26,
    28.150000000000002,
    68.82000000000001,
    28.34,
    68.38000000000001
  );
  ctx.bezierCurveTo(
    28.419999999999998,
    68.18,
    28.51,
    67.99000000000001,
    28.59,
    67.79
  );
  ctx.bezierCurveTo(
    30.63,
    63.17000000000001,
    33.11,
    58.78000000000001,
    35.96,
    54.68000000000001
  );
  ctx.lineTo(67.13, 86.19000000000001);
  ctx.lineTo(23.04, 86.19000000000001);
  ctx.bezierCurveTo(23.9, 81.25, 25.22, 76.38, 27.01, 71.65);
  ctx.closePath();
  ctx.moveTo(68.2, 27.76);
  ctx.bezierCurveTo(68.4, 27.67, 68.59, 27.59, 68.79, 27.5);
  ctx.bezierCurveTo(
    69.23,
    27.31,
    69.66000000000001,
    27.12,
    70.10000000000001,
    26.93
  );
  ctx.bezierCurveTo(70.54, 26.75, 70.99000000000001, 26.56, 71.43, 26.39);
  ctx.bezierCurveTo(
    71.63000000000001,
    26.310000000000002,
    71.82000000000001,
    26.23,
    72.02000000000001,
    26.16
  );
  ctx.bezierCurveTo(
    76.70000000000002,
    24.35,
    81.52000000000001,
    23.02,
    86.4,
    22.15
  );
  ctx.lineTo(86.4, 66.7);
  ctx.lineTo(55.23, 35.2);
  ctx.bezierCurveTo(59.29, 32.32, 63.63, 29.82, 68.2, 27.76);
  ctx.closePath();
  ctx.moveTo(128.04, 26.16);
  ctx.bezierCurveTo(
    128.23999999999998,
    26.24,
    128.42999999999998,
    26.31,
    128.63,
    26.39
  );
  ctx.bezierCurveTo(
    129.07999999999998,
    26.57,
    129.51999999999998,
    26.75,
    129.96,
    26.93
  );
  ctx.bezierCurveTo(130.4, 27.11, 130.84, 27.3, 131.27, 27.5);
  ctx.bezierCurveTo(131.47, 27.59, 131.66, 27.67, 131.86, 27.76);
  ctx.bezierCurveTo(136.43, 29.830000000000002, 140.77, 32.33, 144.83, 35.2);
  ctx.lineTo(113.66, 66.7);
  ctx.lineTo(113.66, 22.15);
  ctx.bezierCurveTo(118.55, 23.02, 123.36, 24.35, 128.04, 26.16);
  ctx.closePath();
  ctx.moveTo(171.47, 67.79);
  ctx.bezierCurveTo(
    171.56,
    67.99000000000001,
    171.64,
    68.18,
    171.73,
    68.38000000000001
  );
  ctx.bezierCurveTo(
    171.92,
    68.82000000000001,
    172.10999999999999,
    69.26,
    172.29,
    69.71000000000001
  );
  ctx.bezierCurveTo(
    172.47,
    70.16000000000001,
    172.65,
    70.61000000000001,
    172.82999999999998,
    71.06
  );
  ctx.bezierCurveTo(
    172.91,
    71.26,
    172.98,
    71.46000000000001,
    173.05999999999997,
    71.65
  );
  ctx.bezierCurveTo(
    174.84999999999997,
    76.38000000000001,
    176.17,
    81.25,
    177.02999999999997,
    86.19
  );
  ctx.lineTo(132.93999999999997, 86.19);
  ctx.lineTo(164.10999999999996, 54.67999999999999);
  ctx.bezierCurveTo(166.95, 58.78, 169.43, 63.17, 171.47, 67.79);
  ctx.closePath();
  ctx.moveTo(173.06, 128.27);
  ctx.bezierCurveTo(172.98, 128.47, 172.91, 128.67000000000002, 172.83, 128.86);
  ctx.bezierCurveTo(
    172.66000000000003,
    129.31,
    172.48000000000002,
    129.76000000000002,
    172.29000000000002,
    130.21
  );
  ctx.bezierCurveTo(
    172.11,
    130.65,
    171.92000000000002,
    131.1,
    171.73000000000002,
    131.54000000000002
  );
  ctx.bezierCurveTo(
    171.64000000000001,
    131.74,
    171.56000000000003,
    131.94000000000003,
    171.47000000000003,
    132.13000000000002
  );
  ctx.bezierCurveTo(
    169.43000000000004,
    136.75000000000003,
    166.95000000000002,
    141.14000000000001,
    164.11,
    145.24
  );
  ctx.lineTo(132.94, 113.73);
  ctx.lineTo(177.03, 113.73);
  ctx.bezierCurveTo(176.16, 118.67, 174.84, 123.54, 173.06, 128.27);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.restore();
};
